<div *ngIf="filterNav?.refinementType === 'RangeRefinementMenu'">
  <app-usf-expandable-panel
    title="{{ filterNav.displayName }}"
    [collapseContent]="!filterNav.isExpended"
  >
    <div class="refinement-section" data-cy="range-refinement-menu-section">
      <div
        [ngClass]="[
          (this.platformService?.isTouchExperience$ | async)
            ? 'touch'
            : 'desktop',
        ]"
      >
        <div *ngFor="let range of rangeRefinements; let i = index">
          {{ range.displayName }}<br />
          <label
            class="sr-only"
            [attr.data-cy]="
              'range-refinement-menu-' + i + '-label-minimum-value'
            "
            for="minVal-{{ i }}"
            >{{ 'i18n.search.searchFilters.minimumValue' | translate }}</label
          >
          <ion-input
            type="text"
            inputmode="numeric"
            min="0"
            maxlength="3"
            [attr.data-cy]="
              'range-refinement-menu-' + i + '-input-minimum-value'
            "
            id="minVal-{{ i }}"
            [(ngModel)]="range.minVal"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="changeRangeValue(range, $event, range.maxVal)"
          ></ion-input>
          <span class="divider">to</span>
          <label
            class="sr-only"
            for="maxVal-{{ i }}"
            [attr.data-cy]="
              'range-refinement-menu-' + i + '-label-maximum-value'
            "
            >{{ 'i18n.search.searchFilters.maximumValue' | translate }}</label
          >
          <ion-input
            id="maxVal-{{ i }}"
            type="text"
            inputmode="numeric"
            [attr.data-cy]="
              'range-refinement-menu-' + i + '-input-maximum-value'
            "
            min="0"
            maxlength="3"
            [(ngModel)]="range.maxVal"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="changeRangeValue(range, range.minVal, $event)"
          ></ion-input>
          <span
            class="divider"
            [attr.data-cy]="'range-refinement-menu-' + i + '-label-uom'"
            >{{ range.uom }}</span
          >
        </div>
      </div>
    </div>
    <a
      href="javascript:void(0)"
      data-cy="range-refinement-menu-reset-all-ranges"
      (click)="resetAllRanges()"
      >{{ 'i18n.search.searchFilters.resetAllNutritional' | translate }}</a
    >
  </app-usf-expandable-panel>
</div>
